import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import Header from './components/Header';
import Slider from './components/Slider';
import Hero from './components/Hero';
import Features from './components/Features';
import FAQs from './components/FAQs';
import Footer from './components/Footer';
import Signup from './components/Signup';
import ContactForm from './components/ContactForm';
import ScrollToTop from './components/ScrollToTop';
import TrustTestimonials from './components/TrustTestimonials';
import ScrollToTopButton from './components/ScrollToTopButton';
import SpecialOfferModal from './components/SpecialOfferModal';
import BlogList from "./components/Blog/BlogList";
import BlogDetail from "./components/Blog/BlogDetail";
import ContactModal from './components/Contact';
import InfographicModalSection from './components/InfographicModalSection';

// ---- CLARITY helper ----
const track = (name, props = {}) => {
  if (typeof window !== 'undefined' && window.clarity) {
    window.clarity('event', name, props);
  }
};

/**
 * Normalize weird landing URLs (e.g., Facebook in-app browser):
 * https://myboq.in?fbclid=...  -> ensure pathname is "/"
 * Also logs landing environment to Clarity for debugging.
 */
const NormalizeLanding = () => {
  const location = useLocation();

  useEffect(() => {
    try {
      // Ensure pathname exists (some WebViews behave oddly)
      const { pathname, search, hash } = window.location;
      if (!pathname || pathname === '') {
        window.history.replaceState({}, '', '/' + (search || '') + (hash || ''));
      }

      // Clarity: capture environment (helps compare FB vs Google)
      track('landing_env', {
        path: window.location.pathname || '',
        search: window.location.search || '',
        ref: document.referrer || 'none',
        ua: navigator.userAgent || 'unknown',
      });
    } catch (e) {
      // no-op
    }
    // run only once on app mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Track route changes (optional, but helpful)
  useEffect(() => {
    track('route_change', { path: location.pathname });
  }, [location.pathname]);

  return null;
};

function App() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const openModal = () => {
    setIsContactModalOpen(true);
    track('contact_modal_open', { placement: 'app' });
  };

  const closeModal = () => {
    setIsContactModalOpen(false);
    track('contact_modal_close', { placement: 'app' });
  };

  return (
    <>
      <NormalizeLanding />

      {/* Header with contact trigger */}
      <Header openModal={openModal} />
      <ScrollToTop />

      {/* Route Pages */}
      <Routes>
        <Route
          path="/"
          element={
            <>
              {/* Only shown on home page */}
              <SpecialOfferModal />
              <Slider />
              <Hero />
              <InfographicModalSection />

              <TrustTestimonials />
              <FAQs />

              <div className="flex justify-center my-6">
                <button
                  onClick={() => {
                    track('contact_demo_click', { placement: 'home_cta' });
                    openModal();
                  }}
                  className="bg-orange-500 text-white py-2 px-6 rounded hover:bg-orange-600 transition"
                >
                  Contact for Demo
                </button>
              </div>
            </>
          }
        />

        <Route path="/signup" element={<Signup />} />
        {/* <Route path="/pricing" element={<Pricing />} /> */}
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/features" element={<Features />} />

        {/* Blog routes */}
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />

        <Route
          path="*"
          element={<h1 className="text-center text-2xl mt-10">Page Not Found</h1>}
        />
      </Routes>

      {/* Footer and other fixed components */}
      <Footer />

      <ContactModal
        isOpen={isContactModalOpen}
        onClose={closeModal}
        apiEndpoint="/submit"
      />

      <ScrollToTopButton />
    </>
  );
}

export default App;
